import React from 'react';
import styles from './nexus-backdrop.css';

/* DOM matches submenus/settings.html blur-balls-bg */
const NexusBackdrop = () => (
    <div
        className={styles.backdrop}
        aria-hidden="true"
    >
        <div className={`${styles.ball} ${styles.ball1}`} />
        <div className={`${styles.ball} ${styles.ball2}`} />
        <div className={`${styles.ball} ${styles.ball3}`} />
        <div className={`${styles.ball} ${styles.ball4}`} />
    </div>
);

export default NexusBackdrop;
